import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import './copyright.less';
import copyrightIcon from '../../resource/img/icon-copyright.png';

class Copyright extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        const {intlr} = this.props;
        return (
            <a id='copyright' href='http://mblock.cc/' target='_blank' rel='noopener noreferrer'>
                <img src={copyrightIcon}/>
                {intlr.messages['COPYRIGHT.TEXT']}
            </a>
        );
    }
}

const mapStateToProps = state => ({
    intlr: state.intlr
});


export default withRouter(connect(
    mapStateToProps
)(Copyright));